import React from 'react';
import { IconArrowUpBold } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';

interface EssentialsTitleProps {
  is_opened: boolean;
  onClickToggle: () => void;
}

export const ProductInfoProvidedNoticeTitle: React.FC<React.PropsWithChildren<EssentialsTitleProps>> = ({ is_opened, onClickToggle }) => {
  return (
    <Title className={Typography.BODY_16_SEMIBOLD} onClick={onClickToggle} is_opened={is_opened} data-allow-preview>
      {'상품정보 제공고시'}
      <IconArrowUpBold v3Color='gray950' width={24} height={24} className='icon' />
    </Title>
  );
};

const Title = styled.h4<{ is_opened?: boolean }>`
  position: relative;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  color: ${vars.v3Color.gray950};

  .icon {
    position: absolute;
    right: 12px;
    transform: rotate(180deg);
  }

  ${({ is_opened }) =>
    is_opened &&
    css`
      .icon {
        transform: rotate(0deg);
      }
    `}
`;
